import { createContext, useReducer } from 'react'
import phaseReducer from './PhaseReducer'

const PhaseContext = createContext()

export const PhaseProvider = ({ children }) => {
  const initialState = {
    phases: [],
    phase: {},
    round: {},
    loading: false,
  }

  const [state, dispatch] = useReducer(phaseReducer, initialState)

  return (
    <PhaseContext.Provider
      value={{
        ...state,
        dispatch,
      }}
    >
      {children}
    </PhaseContext.Provider>
  )
}

export default PhaseContext
